/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 08/10/2025 - 19:59:47
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 08/10/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useState } from "react";
import { Button, Image } from "react-bootstrap";
import { auth, googleProvider } from "../../firebase";
import { signInWithPopup, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import images from "../../images/index";
import Loader from "../shared/loader";
import { locationapi } from "../../api/locationapi";

const GoogleLogin: React.FC = () => {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const googleLogin = async () => {
    setLoader(true);
    setError("");
    
    try {
      await signOut(auth);
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      const locationCheck = await locationapi.trackUserLocation();
      
      if (locationCheck.blocked) {
        await signOut(auth);
        setError(locationCheck.message || "PV-GlareCheck is not available in your region");
        setLoader(false);
        return;
      }

      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (!userDoc.exists()) {
        await setDoc(doc(db, "users", user.uid), {
          firstName: user.displayName?.split(" ")[0] || "",
          foreName: user.displayName?.split(" ")[1] || "",
          email: user.email,
          photoURL: user.photoURL,
          createdAt: new Date(),
          userId: user.uid
        });
      }
      
      if (auth.currentUser) {
        const token = await auth.currentUser.getIdToken();
        localStorage.setItem('firebaseToken', token);
      }
      navigate("/dashboard");
    } catch (error) {
      console.error("Error in Google sign in:", error);
      setError("Error in Google sign in");
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <Button onClick={googleLogin} className="googleLogin my-2" variant="none">
        {loader ? (
          <span className="d-flex justify-content-center">
            <Loader />
          </span>
        ) : (
          <>
            <Image width={20} className="pb-1 mx-2" src={images.GoogleIcon} /> Google
          </>
        )}
      </Button>
      {error && <small className="text-danger d-block">{error}</small>}
    </>
  );
};

export default GoogleLogin;